import {
  DefaultUrlSerializer,
  UrlTree
} from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    const urlTree = super.parse(url);
    urlTree.root.children?.['primary']?.segments?.forEach((x) => {
      x.path = x.path.toLowerCase();
    });
    //console.log(`[urlTree] to string ${urlTree.toString()}`, urlTree);
    return urlTree;
  }
}
